import blog3 from '../assets/img/blog/1.jpg';
import blog4 from '../assets/img/blog/2.jpg';
import blog5 from '../assets/img/blog/3.jpg';
import blog6 from '../assets/img/blog/4.jpg';
import blog7 from '../assets/img/blog/5.jpg';
import blog8 from '../assets/img/blog/6.jpg';
import blog9 from '../assets/img/blog/7.jpg';
import blog10 from '../assets/img/blog/8.jpg';
import blog11 from '../assets/img/blog/9.jpg';
import blog12 from '../assets/img/blog/10.jpg';
import blog13 from '../assets/img/blog/11.jpg';
import blog14 from '../assets/img/blog/12.jpg';
import blog15 from '../assets/img/blog/14.jpg';
import blog16 from '../assets/img/blog/13.jpg';
import blog17 from '../assets/img/blog/15.jpg';
import blog18 from '../assets/img/blog/16.jpg';
import blog19 from '../assets/img/blog/17.jpg';
import blog20 from '../assets/img/blog/18.jpg';

import blog21 from '../assets/img/blog/blog20.jpg';
import blog22 from '../assets/img/blog/blog21.jpg';
import blog23 from '../assets/img/blog/blog22.jpg';
import blog24 from '../assets/img/blog/blog23.jpg';
import blog25 from '../assets/img/blog/blog24.jpg';
import blog26 from '../assets/img/blog/blog25.jpg';
import blog27 from '../assets/img/blog/blog26.jpg';
import blog28 from '../assets/img/blog/blog27.jpg';
import blog29 from '../assets/img/blog/blog28.jpg';
import blog30 from '../assets/img/blog/blog29.jpg';
import blog31 from '../assets/img/blog/blog30.jpg';
import blog32 from '../assets/img/blog/blog31.jpg';
import blog33 from '../assets/img/blog/blog32.jpg';
import blog34 from '../assets/img/blog/blog33.jpg';
import blog35 from '../assets/img/blog/blog34.jpg';
import blog36 from '../assets/img/blog/blog35.jpg';
import blog37 from '../assets/img/blog/blog36.jpg';
import blog38 from '../assets/img/blog/blog37.jpg';
import blog39 from '../assets/img/blog/blog38.jpg';
import blog40 from '../assets/img/blog/blog39.jpg';
import blog41 from '../assets/img/blog/blog40.jpg';
import blog42 from '../assets/img/blog/blog41.jpg';
import blog43 from '../assets/img/blog/blog42.jpg';
import blog44 from '../assets/img/blog/blog43.jpg';
import blog45 from '../assets/img/blog/blog44.jpg';
import blog46 from '../assets/img/blog/blog45.jpg';
import blog47 from '../assets/img/blog/blog46.jpg';
import blog48 from '../assets/img/blog/blog47.jpg';
import blog49 from '../assets/img/blog/blog48.jpg';
import blog50 from '../assets/img/blog/blog49.jpg';
import blog51 from '../assets/img/blog/blog50.jpg';
import blog52 from '../assets/img/blog/blog51.jpg';
import blog53 from '../assets/img/blog/blog52.jpg';
import blog54 from '../assets/img/blog/blog53.jpg';
import blog55 from '../assets/img/blog/blog54.jpg';
import blog56 from '../assets/img/blog/blog55.jpg';
import blog57 from '../assets/img/blog/blog56.jpg';
import blog58 from '../assets/img/blog/blog57.jpg';
import blog59 from '../assets/img/blog/blog58.jpg';
import blog60 from '../assets/img/blog/blog59.jpg';
import blog61 from '../assets/img/blog/blog60.jpg';
import blog62 from '../assets/img/blog/blog61.jpg';
import blog63 from '../assets/img/blog/blog62.jpg';
import blog64 from '../assets/img/blog/blog63.jpg';
import blog65 from '../assets/img/blog/blog64.jpg';
import blog66 from '../assets/img/blog/blog65.jpg';
import blog67 from '../assets/img/blog/blog66.jpg';
import blog68 from '../assets/img/blog/blog67.jpg';
import blog69 from '../assets/img/blog/blog68.jpg';
import blog70 from '../assets/img/blog/blog69.jpg';
import blog71 from '../assets/img/blog/blog70.jpg';
import blog72 from '../assets/img/blog/blog71.jpg';
import blog73 from '../assets/img/blog/blog72.jpg';
import blog74 from '../assets/img/blog/blog73.jpg';
import blog75 from '../assets/img/blog/blog74.jpg';
import blog76 from '../assets/img/blog/blog75.jpg';
import blog77 from '../assets/img/blog/blog76.jpg';
import blog78 from '../assets/img/blog/blog77.jpg';
import blog79 from '../assets/img/blog/blog78.jpg';
import blog80 from '../assets/img/blog/blog79.jpg';
import blog81 from '../assets/img/blog/blog80.jpg';
import blog82 from '../assets/img/blog/blog81.jpg';
import blog83 from '../assets/img/blog/blog82.jpg';
import blog84 from '../assets/img/blog/blog83.jpg';
import blog85 from '../assets/img/blog/blog84.jpg';
import blog86 from '../assets/img/blog/blog85.jpg';
import blog87 from '../assets/img/blog/blog86.jpg';
import blog88 from '../assets/img/blog/blog87.jpg';
import blog89 from '../assets/img/blog/blog88.jpg';

const blogPosts = [
  {
    id: 13,
    title: "How to Build Confidence- Practical Tips from a Fashion Entrepreneur",
    excerpt: "how-to-build-confidence-practical-tips-from-a-fashion-entrepreneur",
    excerptright: "howghg-to-build-confidence-practical-tips-from-a-fashion-entrepreneur",
    image: blog15,
    author: "Bhavana Singh",
    date: "Jun 06, 2025",
    shares: "700",
    link: "blog/how-to-build-confidence-practical-tips-from-a-fashion-entrepreneur",
  },
  {
    id: 14,
    title: "Emotional Intelligence- The Secret to Better Relationships and Leadership",
    excerpt: "emotional-intelligence-the-secret-to-better-relationships-and-leadership",
    image: blog16,
    author: "Bhavana Singh",
    date: "Jun 06, 2025",
    shares: "700",
    link: "blog/emotional-intelligence-the-secret-to-better-relationships-and-leadership",
  },
  {
    id: 15,
    title: "Real-Life Transformation Stories- Before and After Style Makeovers",
    excerpt: "real-life-transformation-stories-before-and-after-style-makeovers",
    image: blog17,
    author: "Bhavana Singh",
    date: "Jun 06, 2025",
    shares: "700",
    link: "blog/real-life-transformation-stories-before-and-after-style-makeovers",
  },

  {
    id: 16,
    title: "Modernizing Tradition- How to Style Lehengas and Sarees for Today’s Woman",
    excerpt: "modernizing-tradition-how-to-style-lehengas-and-sarees-for-todays-woman",
    image: blog18,
    author: "Bhavana Singh",
    date: "Jun 06, 2025",
    shares: "700",
    link: "blog/modernizing-tradition-how-to-style-lehengas-and-sarees-for-todays-woman",
  },
  {
    id: 17,
    title: "Mastering Communication Skills for Personal and Professional Success",
    excerpt: "mastering-communication-skills-for-personal-and-professional-success",
    image: blog19,
    author: "Bhavana Singh",
    date: "Jun 06, 2025",
    shares: "700",
    link: "blog/mastering-communication-skills-for-personal-and-professional-success",
  },
  {
    id: 18,
    title: "Celebrity Styling Secrets- Lessons from Bollywood’s Best-Dressed",
    excerpt: "celebrity-styling-secrets-lessons-from-bollywoods-best-dressed",
    image: blog20,
    author: "Bhavana Singh",
    date: "Jun 06, 2025",
    shares: "700",
    link: "blog/celebrity-styling-secrets-lessons-from-bollywoods-best-dressed",
  },
  {
    id: 10,
    title: "How to Build Confidence- Practical Tips from a Fashion Entrepreneur",
    excerpt: "how-to-build-confidence-practical-tips-from-a-fashion-entrepreneur",
    image: blog12,
    author: "Bhavana Singh",
    date: "Jun 06, 2025",
    shares: "700",
    link: "blog/how-to-build-confidence-practical-tips-from-a-fashion-entrepreneur",
  },
  {
    id: 11,
    title: "5 Steps to Transform Your Personality and Boost Your Confidence",
    excerpt: "5-steps-to-transform-your-personality-and-boost-your-confidence",
    image: blog13,
    author: "Bhavana Singh",
    date: "Jun 06, 2025",
    shares: "700",
    link: "blog/5-steps-to-transform-your-personality-and-boost-your-confidence",
  },
  
  {
    id: 12,
    title: "How to Dress for Your Body Shape Without Labels",
    excerpt: "how-to-dress-for-your-body-shape-without-labels",
    image: blog14,
    author: "Bhavana Singh",
    date: "Jun 06, 2025",
    shares: "700",
    link: "blog/how-to-dress-for-your-body-shape-without-labels",
  },
   {
    id: 9,
    title: "The Power of First Impressions: How Image Consulting Can Change Your Life",
    excerpt: "the-power-of-first-impressions-how-image-consulting-can-change-your-life",
    image: blog11,
    author: "Bhavana Singh",
    date: "Jun 06, 2025",
    shares: "700",
    link: "blog/the-power-of-first-impressions-how-image-consulting-can-change-your-life",
  },
 
  {
    id: 2,
    title: "Master Public Speaking: Speak with Confidence and Authenticity",
    excerpt: "Public speaking can feel intimidating, but it’s one of the most powerful skills you can develop.",
    image: blog5,
    author: "Bhavana Singh",
    date: "January 2, 2025",
    shares: "500",
    link: "blog/master-public-speaking",
  },
  {
    id: 3,
    title: "Top Personal Branding Mistakes to Avoid",
    excerpt: "Your brand is an intentional projection of your skills, values, and experiences. ",
    image: blog6,
    author: "Bhavana Singh",
    date: "April 10, 2025",
    shares: "850",
    link: "blog/top-personal-branding-mistakes-to-avoid",
  },
  {
    id: 4,
    title: "The Role of Professional Development in Personal Branding",
    excerpt: "In this world of a cut-throat economy, a strong personal brand is not a nice-to-have any more, it is a must-have.",
    image: blog7,
    author: "Bhavana Singh",
    date: "May 5, 2025",
    shares: "620",
    link: "blog/the-role-of-professional-development-in-personal-branding",
  },
  {
    id: 5,
    title: "The Importance of Personal Branding in Today's Digital World",
    excerpt: "In our highly connected world, personal branding has become very important.",
    image: blog8,
    author: "Bhavana Singh",
    date: "April 20, 2025",
    shares: "730",
    link: "blog/the-importance-of-personal-branding-in-today-s-digital-world",
  },
  {
    id: 6,
    title: "The Impact of Thought Leadership on Personal Branding",
    excerpt: "The modern digital era requires everyone to build an influential personal brand because it has become an essential requirement.",
    image: blog9,
    author: "Bhavana Singh",
    date: "May 01, 2025",
    shares: "730",
    link: "blog/the-impact-of-thought-leadership-on-personal-branding",
  },
  
 {
    id: 1,
    title: "Personality Makeover: Become the Best Version of Yourself",
    excerpt: "When you hear the term “makeover,” you probably think of fashion, makeup, or hairstyles.",
    image: blog3,
    author: "Bhavana Singh",
    date: "December 25, 2024",
    shares: "1K",
    link: "blog/personality-makeover",
  },
   {
    id: 7,
    title: "Personal Branding for Entrepreneurs: Building Your Business Identity",
    excerpt: "Modern market competition demands entrepreneurs develop more than exceptional products",
    image: blog10,
    author: "Bhavana Singh",
    date: "May 5, 2025",
    shares: "620",
    link: "blog/personal-branding-for-entrepreneurs-building-your-business-identity",
  },
  {
    id: 8,
    title: "Building a Strong Online Presence: Tips and Strategies",
    excerpt: "Modern business success demands organizations to establish a powerful online presence",
    image: blog4,
    author: "Bhavana Singh",
    date: "May 06, 2025",
    shares: "730",
    link: "blog/building-a-strong-online-presence-tips-and-strategies",
  },

 {
    id: 19,
    title: "5 Confidence Rituals You Can Start Today",
    excerpt: "When you hear the term “makeover,” you probably think of fashion, makeup, or hairstyles.",
    image: blog21,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "1K",
    link: "blog/5-confidence-rituals-you-can-start-today",
  },
   {
    id: 20,
    title: "10 Habits of Emotionally Strong Women – Daily Practices for Resilience",
    excerpt: "Modern market competition demands entrepreneurs develop more than exceptional products",
    image: blog22,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "620",
    link: "blog/10-habits-of-emotionally-strong-women-daily-practices-for-resilience",
  },
  {
    id: 21,
    title: "Break Free from Limiting Beliefs – Steps to Rewrite Your Inner Story",
    excerpt: "Modern business success demands organizations to establish a powerful online presence",
    image: blog23,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "730",
    link: "blog/break-free-from-limiting-beliefs-steps-to-rewrite-your-inner-story",
  },

 {
    id: 22,
    title: "Career Confused? Ask These 5 Questions – Gain Clarity on Your True Path",
    excerpt: "When you hear the term “makeover,” you probably think of fashion, makeup, or hairstyles.",
    image: blog24,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "1K",
    link: "blog/career-confused-ask-these-5-questions-gain-clarity-on-your-true-path",
  },
   {
    id: 23,
    title: "Coaching vs. Therapy: What’s Right for You?",
    excerpt: "Modern market competition demands entrepreneurs develop more than exceptional products",
    image: blog25,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "620",
    link: "blog/coaching-vs-therapy-what’s-right-for-you",
  },

  {
    id: 24,
    title: "From Self-Doubt to Self-Worth – A Guide to Building Unshakable Confidence",
    excerpt: "Modern business success demands organizations to establish a powerful online presence",
    image: blog26,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "730",
    link: "blog/from-self-doubt-to-self-worth-a-guide-to-building-unshakable-confidence",
  },

 {
    id: 25,
    title: "How to Reconnect with Your Inner Power",
    excerpt: "When you hear the term “makeover,” you probably think of fashion, makeup, or hairstyles.",
    image: blog27,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "1K",
    link: "blog/how-to-reconnect-with-your-inner-power",
  },
   {
    id: 26,
    title: "How to Say ‘No’ Without Feeling Guilty",
    excerpt: "Modern market competition demands entrepreneurs develop more than exceptional products",
    image: blog28,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "620",
    link: "blog/how-to-say-no-without-feeling-guilty",
  },
  {
    id: 27,
    title: "How to Stop People-Pleasing and Start Living Authentically",
    excerpt: "Modern business success demands organizations to establish a powerful online presence",
    image: blog29,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "730",
    link: "blog/how-to-stop-people-pleasing-and-start-living-authentically",
  },

 {
    id: 27,
    title: "My Journey from Chaos to Clarity: What I Learned",
    excerpt: "When you hear the term “makeover,” you probably think of fashion, makeup, or hairstyles.",
    image: blog29,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "1K",
    link: "blog/my-journey-from-chaos-to-clarity-what-i-learned",
  },
   {
    id: 28,
    title: "Simple Mindset Shifts That Change Everything",
    excerpt: "Modern market competition demands entrepreneurs develop more than exceptional products",
    image: blog30,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "620",
    link: "blog/simple-mindset-shifts-that-change-everything",
  },
  {
    id: 29,
    title: "The Power of Self-Awareness – Why All Transformation Starts Within",
    excerpt: "Modern business success demands organizations to establish a powerful online presence",
    image: blog30,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "730",
    link: "blog/the-power-of-self-awareness-why-all-transformation-starts-within",
  },

 {
    id: 30,
    title: "The Secret to Setting Boundaries That Stick",
    excerpt: "When you hear the term “makeover,” you probably think of fashion, makeup, or hairstyles.",
    image: blog31,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "1K",
    link: "blog/the-secret-to-setting-boundaries-that-stick",
  },
   {
    id: 31,
    title: "The Secret to Setting Boundaries That Stick",
    excerpt: "Modern market competition demands entrepreneurs develop more than exceptional products",
    image: blog32,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "620",
    link: "blog/the-secret-to-setting-boundaries-that-stick",
  },
  {
    id: 32,
    title: "Top 3 Signs You’re Ready for a Life Transformation",
    excerpt: "Modern business success demands organizations to establish a powerful online presence",
    image: blog33,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "730",
    link: "blog/top-3-signs-you’re-ready-for-a-life-transformation",
  },
  {
    id: 33,
    title: "Why Every Woman Needs a Life Coach in Her 30s?",
    excerpt: "Modern business success demands organizations to establish a powerful online presence",
    image: blog34,
    author: "Bhavana Singh",
    date: "August 25, 2025",
    shares: "730",
    link: "blog/why-every-woman-needs-a-life-coach-in-her-30s",
  },
 
  
  
  
  
  
];

export default blogPosts;
